import { collectionEngineV1 } from '../apis';
const tenantBillingAPI = collectionEngineV1('/tenant-billing');
const notScopedTenantBillingAPI = collectionEngineV1('/tenant-billing', false);
export const getInvoice = (invoiceId) => {
    return tenantBillingAPI('GET', `/${invoiceId || 'wip'}`);
};
export const getInvoices = () => {
    return tenantBillingAPI('GET', '/');
};
export const invoice = (tenantId) => {
    return notScopedTenantBillingAPI('POST', `/${tenantId}`);
};
export const customInvoice = (tenantId, customInvoice) => {
    return notScopedTenantBillingAPI('POST', `/custom-invoice/${tenantId}`, {
        body: customInvoice,
    });
};
export const updateWIPInvoiceLines = (sku, amount) => {
    return tenantBillingAPI('PATCH', `/${sku}`, {
        body: {
            amount,
        },
    });
};
//# sourceMappingURL=tenant-billing.js.map